export default class AuthenticatedException extends Error {
  constructor(...args) {
    super(...args);
    this.message = 'user is not guest.';
  }
}
